// removed by extract-text-webpack-plugin
module.exports = {"collectionCard":"FI8At1hLnZ2leJfKOWtvE","card":"_3TCyqhC7y5NuSgbrmuZXiK","thumbnail":"_5eGoFqT1VOpsSysUl27Bp","cardImg":"_1yXpxKtCghWva8eLExa0m3","totalItem":"trkwsVUEjcnU14qW17s0Y","quantity":"_16zBFpIvJdmUnLSFelS3Sn","text":"W_LTDldprf60TUyX59R5C","content":"qhhyk2b8aUpoasS1V9wTR","name":"_-cZdZtiiPuDrHWQFm7_MC","likesCmt":"_2d6Ts9AKAiwAFAVi7XEn9Q","left":"_1SN8_ifkdqwn12ayi_Gu0z","like":"_2gsRwCnosGgBT3MGlKhLs1","right":"_2-AROgLrHFPpjblMdsHl6-","cardStack1":"_36S99z8YclKrSM5vXSN1ZZ","cardStack2":"_2MZTnmS2L036vgX7bU2EVC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/CollectionCard.scss
// module id = 1083
// module chunks = 0